import type { NavLink } from "../../shared/types/navigation";

export const topNavLinks: NavLink[] = [
  { label: "サービス", href: "#services" },
  { label: "強み", href: "#strengths" },
  { label: "開発の流れ", href: "#process" },
  { label: "実績", href: "#works" },
  { label: "料金プラン", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
  { label: "お問い合わせ", href: "#contact" },
  {
    label: "代表プロフィール",
    href: "/profile",
    external: true,
    icon: "ri-external-link-line",
  },
];
